module.exports = __webpack_public_path__ + "images/application/bg-stripes-882c2795.png";